const maskPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) {
    return "";
  }
  const maskedPart = phoneNumber.slice(0, -3).replace(/\d/g, "*");
  const visiblePart = phoneNumber.slice(-3);

  return maskedPart + visiblePart;
};
const openPrivacyPage = () => {
  window.open("https://www.hejazfs.com.au/privacy-policy", "_blank");
};
const openTermConditionsPage = () => {
  window.open(
    "https://learninghub.hejazfs.com.au/hubfs/Hejaz%20Terms%20and%20Condition%20-%20Auto%20Finance.pdf?_gl=11vy4x73_gcl_auOTU5NzA3ODEwLjE3NTA3Mjc5NDc._gaMTU2Mjg1NzI0Mi4xNzUwNzI3OTQ2_ga_SHT96S6TFL*czE3NTA3Mjc5NDYkbzEkZzAkdDE3NTA3MjgwMzgkajYwJGwwJGgw&_ga=2.78673812.1659573991.1750727947-1562857242.1750727946",
    "_blank"
  );
};

export { maskPhoneNumber, openPrivacyPage, openTermConditionsPage };
